

import { Box } from "@mui/material";
import { CircularProgress } from "@mui/material";
import { Typography } from "@mui/material";

export const Loading = ({ message = 'Cargando...', subMessage = 'Por favor espere mientras se cargan los datos' }) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center',
        justifyContent: 'center',
        padding: 4,
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        maxWidth: 500,
        margin: '40px auto',
        minHeight: 300,
        bgcolor: 'white', 
        border: '1px solid #e0e0e0',
        width: '100%'
      }}
    >
      <CircularProgress 
        size={60} 
        thickness={4}
        style={{ 
          color: '#343c89',
          animationDuration: '800ms'
        }} 
      />
      <Typography 
        variant="h6" 
        style={{ 
          color: '#343c89',
          fontWeight: 600,
          letterSpacing: '0.5px',
          marginTop: '20px'
        }}
      >
        {message}
      </Typography>
      {subMessage && (
        <Typography 
          variant="caption" 
          style={{ 
            color: '#666',
            textAlign: 'center',
            maxWidth: '80%',
            marginTop: '10px'
          }}
        >
          {subMessage}
        </Typography>
      )}
    </Box>
  );
}
